/**
 * The driver's default card as GET /billing/payment-methods names it: its
 * id, a display brand ("Mastercard") and the last 4. The screen before a
 * start labels the Card option with it, and the wallet top-up confirmation
 * names the card it will charge (and sends this id, so the card shown is the
 * card charged). Nulls when no card is on file or the list has not loaded.
 */
export interface DefaultCardSummary {
  id: string | null;
  brand: string | null;
  last4: string | null;
}

export function defaultCardSummary(
  methods: { default_payment_method: string | null; payment_methods: Array<{ id: string; brand?: string; last4?: string }> } | undefined,
): DefaultCardSummary {
  if (!methods?.default_payment_method) return { id: null, brand: null, last4: null };
  const pm = methods.payment_methods.find((m) => m.id === methods.default_payment_method);
  if (!pm) return { id: null, brand: null, last4: null };
  return {
    id: pm.id,
    brand: pm.brand ? cardBrandName(pm.brand) : null,
    last4: pm.last4 ?? null,
  };
}

const BRAND_NAMES: Record<string, string> = {
  amex: 'American Express',
  american_express: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
};

/** Stripe's brand code as people write it: "mastercard" is "Mastercard". */
export function cardBrandName(brand: string): string {
  const key = brand.trim().toLowerCase();
  const named = BRAND_NAMES[key];
  if (named) return named;
  return key ? key.charAt(0).toUpperCase() + key.slice(1) : brand;
}
